import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faPlusCircle,
	faExternalLinkAlt,
	faEdit,
	faPlus,
	faMinus,
	faArrowRightArrowLeft,
	faFilePdf,
	faCopy,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import FieldPortal from '@/components/edit/FieldPortal/index.vue'
import MessageError from '@/components/edit/MessageError/index.vue'
import ManageArray from '@/components/edit/ManageArray/index.vue'
import MessageErrorAlert from '@/components/edit/MessageErrorAlert/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'
import TableTrialDetail from '@/views/GroupsDetail/TableTrialDetail/index.vue'
import UploadReport from '@/components/edit/UploadReport/index.vue'
import ListLastReports from '@/components/edit/ListLastReports/index.vue'

import InputPortal from '@/components/edit/InputPortal/index.vue'
import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'

import { validationMixin } from 'vuelidate'
import { minLength } from 'vuelidate/lib/validators'

import Control from '@/helpers/control'
import api from '@/helpers/fetch'
import { Validations } from 'vuelidate-property-decorators'
import vSelect from 'vue-select'

import { bus } from '@/main'

library.add(
	faTrashAlt,
	faPlusCircle,
	faExternalLinkAlt,
	faEdit,
	faPlus,
	faMinus,
	faArrowRightArrowLeft,
	faFilePdf,
	faCopy,
)

Vue.component('v-select', vSelect)

@Component({
	components: {
		Loader,
		MessageError,
		MessageSuccess,
		FieldPortal,
		MessageErrorAlert,
		TableTrialDetail,
		InputPortal,
		TypeableDatePortal,
		ManageArray,
		UploadReport,
		ListLastReports,
	},
	mixins: [validationMixin],
})
export default class Judiciary extends Vue {
	@Prop({ default: null, type: Object }) group
	@Prop({ default: () => [], type: Array }) users

	control = new Control()

	loadingTrial = false
	saving = false
	success = false
	error = ''
	lastSaveDate: Date | null = null
	selectedTrialId = 0
	currentMainTrialId = 0
	view: null | string = null

	diff: null | any[] = null
	diffData: null | any
	blockedDiff = false
	blockRemetente = false

	totalAdded = 0
	totalRemoved = 0

	newCNJ = ''
	loadingNewCnj = false
	errorDuplicateCnj = false
	messageError = ''

	sitDate = ''

	updatingAllDates = false
	updatingAllDatesResult = null

	court_costs_to_key = 0
	reportSendingTo_key = 0

	clientFilter = null

	fieldsMonthsLabels = {
		reportSendingOnJan: 'Janeiro',
		reportSendingOnFeb: 'Fevereiro',
		reportSendingOnMar: 'Março',
		reportSendingOnApr: 'Abril',
		reportSendingOnMay: 'Maio',
		reportSendingOnJun: 'Junho',
		reportSendingOnJul: 'Julho',
		reportSendingOnAug: 'Agosto',
		reportSendingOnSep: 'Setembro',
		reportSendingOnOct: 'Outubro',
		reportSendingOnNov: 'Novembro',
		reportSendingOnDec: 'Dezembro',
	}

	async mounted() {
		// Se ainda não tiver valor, defina o padrão
		if (!this.group.court_costs_type) {
			this.group.court_costs_type = 'Pagamento externo'
			this.duplicateReportSendingTo()
		}

		const res = await api.get(
			'/api/groups/' + this.$route.params.clientId + '/open-email-logs',
		)
		if (res.ok) {
			if (res.data.length) {
				this.blockRemetente = true
			}
		}
		this.loadCheckedTrials()
	}

	get totalTrials() {
		return this.filteredTrials.filter(
			(item) => !item.trial.closed && !item.trial.mainTrial,
		).length
	}

	get totalDesdobramentos() {
		return this.filteredTrials.filter(
			(item) => !item.trial.closed && item.trial.mainTrial,
		).length
	}

	// get filteredTrials() {
	// 	if (this.clientFilter === null) {
	// 		return this.group.trials
	// 	} else {
	// 		const mainTrialsIds = this.group.trials.reduce(
	// 			(mainTrials, item) => {
	// 				for (let i = 0; i < item.trial.clients.length; i++) {
	// 					if (
	// 						item.trial.clients[i].client.CNPJOrCPF ===
	// 						this.clientFilter
	// 					) {
	// 						mainTrials.push(item.trial.id)
	// 					}
	// 				}

	// 				return mainTrials
	// 			},
	// 			[],
	// 		)

	// 		return this.group.trials.filter((item) => {
	// 			for (let i = 0; i < mainTrialsIds.length; i++) {
	// 				if (
	// 					item.trial.id === mainTrialsIds[i] ||
	// 					item.trial.mainTrial?.id === mainTrialsIds[i]
	// 				) {
	// 					return true
	// 				}
	// 			}
	// 			return false
	// 		})
	// 	}
	// }

	// get filteredTrials() {
	// 	if (this.clientFilter === null) {
	// 		// Retorna cópia ordenada dos trials originais
	// 		return [...this.group.trials].sort(
	// 			(a, b) => Number(a.trial.id) - Number(b.trial.id),
	// 		)
	// 	} else {
	// 		const mainTrialsIds = this.group.trials.reduce(
	// 			(mainTrials, item) => {
	// 				for (let i = 0; i < item.trial.clients.length; i++) {
	// 					if (
	// 						item.trial.clients[i].client.CNPJOrCPF ===
	// 						this.clientFilter
	// 					) {
	// 						mainTrials.push(item.trial.id)
	// 					}
	// 				}
	// 				return mainTrials
	// 			},
	// 			[],
	// 		)

	// 		// Filtra os trials e depois ordena
	// 		const filtered = this.group.trials.filter((item) => {
	// 			for (let i = 0; i < mainTrialsIds.length; i++) {
	// 				if (
	// 					item.trial.id === mainTrialsIds[i] ||
	// 					item.trial.mainTrial?.id === mainTrialsIds[i]
	// 				) {
	// 					return true
	// 				}
	// 			}
	// 			return false
	// 		})

	// 		// Ordena o resultado filtrado por trial.id ascendente
	// 		return [...filtered].sort(
	// 			(a, b) => Number(a.trial.id) - Number(b.trial.id),
	// 		)
	// 	}
	// }

	get filteredTrials() {
		const reorderTrials = (trials: any[]) => {
			const mainTrials: any[] = []
			const splittings: any[] = []
			const mainTrialMap = new Map<number, any[]>()

			// Separar trials principais e desdobramentos
			trials.forEach((item) => {
				if (item.trial?.mainTrial) {
					splittings.push(item)
				} else {
					mainTrials.push(item)
					mainTrialMap.set(item.trial.id, [])
				}
			})

			// Associar desdobramentos aos trials principais
			splittings.forEach((item) => {
				const mainTrialId = item.trial.mainTrial?.id
				if (
					mainTrialId !== undefined &&
					mainTrialMap.has(mainTrialId)
				) {
					const children = mainTrialMap.get(mainTrialId)
					if (children) {
						children.push(item)
					}
				}
			})

			// Ordenar trials principais por ID
			mainTrials.sort((a, b) => Number(a.trial.id) - Number(b.trial.id))

			// Construir lista final com desdobramentos após seus principais
			const result: any[] = []
			mainTrials.forEach((main) => {
				result.push(main)
				const children = mainTrialMap.get(main.trial.id) || []
				if (children.length > 0) {
					children.sort(
						(a, b) => Number(a.trial.id) - Number(b.trial.id),
					)
					children.forEach((child) => result.push(child))
				}
			})

			return result
		}

		// Lógica de filtragem
		if (this.clientFilter === null) {
			return reorderTrials([...this.group.trials])
		} else {
			const mainTrialsIds: number[] = []

			this.group.trials.forEach((item) => {
				if (item.trial?.clients) {
					for (const client of item.trial.clients) {
						if (client.client?.CNPJOrCPF === this.clientFilter) {
							mainTrialsIds.push(item.trial.id)
							break
						}
					}
				}
			})

			const filtered = this.group.trials.filter((item) => {
				return mainTrialsIds.some(
					(id) =>
						item.trial?.id === id ||
						item.trial?.mainTrial?.id === id,
				)
			})

			return reorderTrials([...filtered])
		}
	}

	copy(cnj): void {
		navigator.clipboard.writeText(cnj)

		this.$bvToast.toast('CNJ copiado!', {
			title: 'Sucesso!',
			variant: 'success',
			noCloseButton: true,
			noAutoHide: false,
			toaster: 'b-toaster-top-center',
		})
	}

	updatePDF() {
		bus.$emit('loadPDF', 'Judicial')
	}

	duplicateReportSendingTo() {
		// Verifica se 'reportSendingTo' é um array válido
		if (
			!this.group.reportSendingTo ||
			!Array.isArray(this.group.reportSendingTo)
		) {
			return
		}

		// Inicializa 'court_costs_to' como array vazio se estiver undefined ou null
		if (
			!this.group.court_costs_to ||
			!Array.isArray(this.group.court_costs_to)
		) {
			this.group.court_costs_to = []
		}

		const reportSendingToCopy = [...this.group.reportSendingTo]

		reportSendingToCopy.forEach((email) => {
			if (!this.group.court_costs_to.includes(email)) {
				this.group.court_costs_to.push(email)
			}
		})

		this.onUpdate(
			this.group.court_costs_to,
			'court_costs_to',
			'court_costs_to',
			'array',
		)
		this.court_costs_to_key++
	}

	@Watch('newCNJ')
	onChange(cnj) {
		this.messageError = ''

		if (!this.$v.newCNJ.$invalid) {
			const onlyNumbers = cnj.replace(/\./g, '').replace('-', '')

			this.createNewTrial(onlyNumbers)
		}
	}

	handleError(errorMessage) {
		this.error = errorMessage
		this.$emit('error', this.error)
	}

	async createNewTrial(cnj) {
		this.loadingNewCnj = true
		this.errorDuplicateCnj = false

		const groupId = this.$route.params.clientId

		const res = await api.post('/api/trial-new', { cnj, group_id: groupId })

		if (res?.ok) {
			window.location.reload()
		} else {
			const msg = res?.msg

			if (
				msg ===
				'Uniqueness violation. duplicate key value violates unique constraint "trials_cnj_key"'
			) {
				this.messageError = 'Já existe um processo com esse CNJ.'
			} else {
				this.messageError = msg
			}
		}
	}

	@Validations()
	validations() {
		return {
			newCNJ: {
				minLength: minLength(25),
				cnjValid,
			},
		}
	}

	onInputReportSendingFrom(userId) {
		this.$emit('onInput', 'reportSendingFrom', userId)
	}

	async onUpdate(array, ref, prop, formatType = 'array') {
		if (array) {
			this.group[prop] = array
			const manageArrayComponent = this.$refs[ref] as any
			manageArrayComponent.setLoading(true)
			const submit =
				formatType === 'object'
					? `{${array.map((item) => `"${item}"`).join(',')}}` // Formato objeto
					: `[${array.map((item) => `"${item}"`).join(', ')}]` // Formato array

			const res = await api.put(
				'/api/groups/' + parseInt(this.$route.params.clientId, 10),
				{ [prop]: submit },
			)

			if (res.ok) {
				manageArrayComponent.setLoading(false)
				manageArrayComponent.setSuccess(true)
				manageArrayComponent.start()
			}
		}
	}

	onInput(name, value) {
		this.$emit('onInput', name, value)
	}

	onInputElaborator(userId) {
		this.$emit('onInput', 'elaborator', userId)
	}

	onInputReviewer(userId) {
		this.$emit('onInput', 'reviewer', userId)
	}

	// pushTrial(trial) {
	// 	// if trial is not open push anchor to router
	// 	if (
	// 		trial.cnj.replace(/[-.]/gi, '') !==
	// 		this.$route.hash.replace(/[#-.]/gi, '')
	// 	) {
	// 		this.$router.push({ hash: '#' + trial.cnj })
	// 		// if trial is open then force reload
	// 	} else {
	// 		this.openTrial(trial)
	// 	}
	// }

	openTrial(trial) {
		// trial loading only triggers on trial id change
		if (this.selectedTrialId === trial.id) {
			this.selectedTrialId = 0
			this.currentMainTrialId = 0
			// this.$router.push({ hash: '' })
			this.updatePDF()
		} else {
			this.selectedTrialId = 0
			this.$nextTick(() => {
				this.currentMainTrialId = trial.mainTrial?.id || null
				this.selectedTrialId = trial.id
				trial.loading = true
				this.updatePDF()
			})
		}
	}

	savingEmit(e) {
		this.$emit('saving', e)
	}

	async onSuccess($event) {
		this.success = $event
		this.lastSaveDate = new Date()
		this.$emit(
			'passSuccessToGrandparent',
			this.success,
			false,
			this.lastSaveDate,
		)
		// bus.$emit('loadPDF')
		bus.$emit('fetchDiff')
	}

	async updateAllDates(date) {
		console.log('date', date)
		const trialsToModify: any[] = []

		if (this?.group?.trials) {
			const trials = this?.group?.trials
			trials.forEach((t) => {
				const cnj = t.trial.cnj.replace(/[.-]/g, '')

				trialsToModify.push({
					cnj,
					currentSituationDate: date,
				})
			})
		}

		this.updatingAllDates = true
		this.updatingAllDatesResult = null

		const result = await api.post(
			'/api/trials/0/current-situation',
			trialsToModify,
		)

		this.updatingAllDates = false
		this.updatingAllDatesResult = result
	}

	clearLoadingBtn(isLoading) {
		if (isLoading) return
		// @ts-ignore
		this.group.trials.forEach((trial) => {
			trial.trial.loading = false
		})
	}

	get storageKey() {
		return `jud-checklist-${this.$route.params.clientId}`
	}

	get allTrialsChecked() {
		return (
			!!this.group?.trials?.length &&
			this.group.trials.every((t) => !!t.trial.checked)
		)
	}

	loadCheckedTrials() {
		const currentKey = this.storageKey
		const raw = localStorage.getItem(currentKey)
		const checkedIds = new Set<number>()
		if (raw) {
			const saved: Array<{ id: number; checked: boolean }> =
				JSON.parse(raw)
			saved.forEach((item) => {
				if (item.checked) checkedIds.add(item.id)
			})
		}

		this.group.trials.forEach((t) => {
			this.$set(t.trial, 'checked', checkedIds.has(t.trial.id))
		})
	}

	saveCheckedTrials() {
		const data = this.group.trials.map((t) => ({
			id: t.trial.id,
			checked: !!t.trial.checked,
		}))
		localStorage.setItem(this.storageKey, JSON.stringify(data))
	}

	toggleAllTrials() {
		const allChecked = this.allTrialsChecked
		this.group.trials.forEach((t) => {
			this.$set(t.trial, 'checked', !allChecked)
		})
		this.saveCheckedTrials()
	}

	getPdfUrl() {
		let host = ''
		let protocol = ''
		let url = '/api/relatorio/' + this.$route.params.clientId
		if (window.location.hostname === 'localhost') {
			host = 'localhost:8734'
			protocol = 'http://'
		}

		if (this.clientFilter) {
			url =
				'/api/groups/' +
				this.$route.params.clientId +
				'/clients/report?cnpj=' +
				this.clientFilter
		}

		if (this.selectedTrialId) {
			url =
				'/api/trials/' +
				(this.currentMainTrialId || this.selectedTrialId) +
				'/report/'
		}

		return protocol + host + url
	}
}

function cnjValid(number) {
	const onlyNumbers = number.replace(/\./g, '').replace('-', '')

	return validaCNJ(onlyNumbers)
}

function validaCNJ(numero) {
	if (numero.length !== 20) {
		return false
	}

	const bcmod = (x, y) => {
		const take = 5
		let mod: string | number = ''

		do {
			const a = parseInt(mod + x.substr(0, take))
			x = x.substr(take)
			mod = a % y
		} while (x.length)

		return mod
	}

	const numeroProcesso = numero.replace(/[.-]/g, '')

	if (numeroProcesso.length < 14 || isNaN(numeroProcesso)) {
		return false
	}

	const digitoVerificadorExtraido = parseInt(numeroProcesso.substr(-13, 2))

	const vara = numeroProcesso.substr(-4, 4)
	const tribunal = numeroProcesso.substr(-6, 2)
	const ramo = numeroProcesso.substr(-7, 1)
	const anoInicio = numeroProcesso.substr(-11, 4)
	const tamanho = numeroProcesso.length - 13
	const numeroSequencial = numeroProcesso.substr(0, tamanho).padStart(7, '0')

	const digitoVerificadorCalculado =
		98 -
		bcmod(
			numeroSequencial + anoInicio + ramo + tribunal + vara + '00',
			'97',
		)

	return digitoVerificadorExtraido === digitoVerificadorCalculado
}
